<template>
    <Dropdown
        class="btn-group"
        trigger-label="OUR SERVICES"
    >
        <template #options>
            <li v-if="dealer.offers_new === 'Y'">
                <a
                    :href="dealerUrl"
                    @click="customEvent('Dealer Locator', 'New Car Sales button', 'Clicked')"
                >
                    New Car Sales
                </a>
            </li>
            <li v-if="dealer.offers_used === 'Y' && dealer.used_stock_count > 0">
                <a
                    :href="dealer.used_url"
                    @click="customEvent('Dealer Locator', 'Used results button', 'Clicked')"
                >
                    Used Car Sales - <span class="stock">{{ dealer.used_stock_count }} in stock!</span>
                </a>
            </li>
            <li v-if="dealer.offers_business === 'Y'">
                <a
                    :href="dealerUrl"
                    @click="customEvent('Dealer Locator', 'Business & Fleet button', 'Clicked')"
                >
                    Business & Fleet
                </a>
            </li>
            <li v-if="dealer.offers_motability === 'Y'">
                <a
                    :href="dealerUrl"
                    @click="customEvent('Dealer Locator', 'Motability button', 'Clicked')"
                >
                    Motability
                </a>
            </li>
            <li v-if="dealer.offers_parts_hub === 'Y'">
                <a
                    :href="dealerUrl"
                    @click="customEvent('Dealer Locator', 'Parts Hub button', 'Clicked')"
                >
                    Parts Hub
                </a>
            </li>
            <li v-if="dealer.offers_servicing === 'Y'">
                <a
                    :href="dealerUrl"
                    @click="customEvent('Dealer Locator', 'Servicing button', 'Clicked')"
                >
                    Servicing
                </a>
            </li>
        </template>
    </Dropdown>
</template>

<script>
    import { defineComponent } from "vue";
    import Dropdown from "../../../components/forms/Dropdown.vue";
    import { customEvent } from "../../../modules/tracking/AnalyticsEvents";

    export default defineComponent({
        name: 'Services',

        components: {
            Dropdown
        },

        data() {
            return {
                selected: null,
            }
        },
        props: {
            dealer: Object
        },

        methods: {
            customEvent: customEvent,
        },

        computed: {
            dealerUrl() {
                return this.dealer.url || '#';
            },
        }
    })
</script>